module.exports = __webpack_public_path__ + "static/F2_image_01-dc6998ca72c811c0bb6ee38545e8422e.png";